import React from 'react';

import { NumberFields } from 'src/jbc-front/components/Form';

// This is Postal code field in thai form
const PostalCodeFieldThai = ({ required, disabled, handleOnChange, prefix = '' , label, onFocus, name }) => (
  <NumberFields
    texts={[]}
    // change length due to using in thailand
    lengths={[5]}
    required={required}
    disabled={disabled}
    label={label}
    prefix={`${prefix}${name}`}
    exactLength
    seperateChar=""
    onChange={handleOnChange}
    noSuffix
    onFocus={onFocus}
  />
)

export default PostalCodeFieldThai;
